// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Zl5Ih","heading":"styles_heading__oVp3m"};